export default "__VITE_ASSET__h4bPHdWK__"